import { styled } from 'styled-components';

export const Description = styled.p`
  border: 0;
  color: var(--grey-light);
  padding: 0;
`;
